// extracted by mini-css-extract-plugin
export default {"container":"MYL13zaQ1HsU5vW4qobR"};